/**
 * Translates enum values send from backend into german language frontend terms
 * @param {string} string the string to be translated
 */
const enumvaluetranslations = (string) => {
    switch (string) {
        case "Confirmed":
            return "Abgeschlossen"
        case "SavedAsDraft":
            return "Entwurf"
        case "CorrectionToDraftAdded":
            return "Entwurf (bearbeitet)"
        case "InTransit":
            return "In Zustellung"
        case "Arrived":
            return "Angekommen"
        case "InProcess":
            return "In Bearbeitung"
        case "Inaccurate":
            return "Fehlerhaft"
        case "PartlyOrFullyReturnedAfterConfimation":
            return "Retourniert"

        case "Cash":
            return "Bar"
        case "ECCard_DebitCard":
            return "EC Karte"
        case "CreditCard":
            return "Kreditkarte"
        case "BankTransfer":
            return "Überweisung"

        case "NewArrivals":
            return "Neuzugänge"
        case "CorrectionForNewArrivals":
            return "Neuzugänge (Korrektur)"
        case "Delivery":
            return "Lieferung"
        case "DamagedGoods":
            return "Fehlerhafte Ware"
        case "Theft":
            return "Diebstahl"
        case "Sales":
            return "Verkauf"
        case "Inventory":
            return "Inventur"
        case "SalesReturns":
            return "Korrektur"
        case "SalesCorrection":
            return "Korrektur"
        case "SalesCorrections":
            return "Korrektur"

        case "OrderRegistered":
            return "Bestellung aufgenommen"
        case "OrderInProgress":
            return "Bestellung in Arbeit"
        case "OrderCanNotBeDelivered":
            return "Ware kann nicht geliefert werden"
        case "OrderArrivedFAEX":
            return "Ware ist bei FAEX angekommen"
        case "OrderCanBeShipped":
            return "Ware kann an Kunden verschickt werden"
        case "OrderShipped":
            return "Ware ist zum Kunden verschickt worden"
        case "OrderWillBePickedUp":
            return "Ware wird vom Kunden abgeholt"
        case "OrderWasPickedUpByCustomer":
            return "Ware wurde vom Kunden abgeholt"
        case "OrderReturned":
            return "Ware kam zurück"
        case "OrderCanceled":
            return "Bestellung ist storniert"
        case "OrderPaymentWaitingForReturn":
            return "Kunde bekommt das Geld zurück"
        case "OrderPaymentReturned":
            return "Kunde hat das Geld zurückbekommen"
        case "OrderComplete":
            return "Bestellung abgeschlossen"


        default:
            return string
    }
}

export { enumvaluetranslations }